import { useContext, useEffect, useState } from 'react';

import queryString from 'query-string';
import { useLocation, useNavigate } from 'react-router';

import Datatable from '../../../Components/Datatable/Datatable';
import { Datepicker, Form, Select, Text } from '../../../Components/Form';
import Loading from '../../../Components/Loading/Loading';
import ModalCustom from '../../../Components/Modal/ModalCustom';
import RemoveModal from '../../../Components/Modal/RemoveModal';
import TitleBar from '../../../Components/TitleBar/TitleBar';
import { useApi } from '../../../Hooks/Api';
import { useToast } from '../../../Hooks/Toast';
import Master from '../../../Layouts/Master';
import { CompetitionContext } from '../Context/CompetitionContext';

const Competition = () => {
  const context = useContext(CompetitionContext);
  const { get, destroy } = useApi();
  const { error, success } = useToast();
  const { search } = useLocation();
  const [loading, setLoading] = useState(true);
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [modalRemoveObject, setModalRemoveObject] = useState(undefined);
  const [removeLoading, setRemoveLoading] = useState(false);
  const [parseParams, setParseParams] = useState({});
  const navigate = useNavigate();
  const [filterModal, setFilterModal] = useState(false);

  useEffect(() => {
    const getData = async () => {
      const params = queryString.parse(search);
      setParseParams(params);
      await getCompetitions();
      await getTypes();
    };
    getData();
  }, [search]);

  const getTypes = async () => {
    setLoading(true);
    await get(
      '/competition/type',
      (res) => {
        let data = [];
        data.push({
          id: 0,
          title: 'همه',
        });
        data.push(...res.data);
        context.types = data;
        setLoading(false);
      },
      (err) => {
        error('دریافت اطلاعات با خطا روبرو شد.');
        setLoading(false);
      },
    );
  };

  const getCompetitions = async (remove = false) => {
    setLoading(true);
    await get(
      `/competition${search}`,
      (res) => {
        context.competitions = res;
        if (remove) {
          setLoading(false);
        }
      },
      (err) => {
        error('هنگام دریافت اطلاعات خطایی رخ داده است.');
        setLoading(false);
      },
    );
  };

  const removeItem = async (id) => {
    setRemoveLoading(true);

    await destroy(
      `/competition/${id}`,
      (res) => {
        success(`مسابقه "${modalRemoveObject?.title}" با موفقیت حذف شد.`);
        setRemoveLoading(false);
        setModalIsOpen(false);
        getCompetitions(true);
      },
      (err) => {
        console.log(err);
        if (err?.status === 422) {
          error(err?.data?.data?.error);
        } else {
          error('حذف به علت خطا انجام نشد.');
        }
        setRemoveLoading(false);
      },
    );
  };

  const competitionFilter = (values, setSubmiting) => {
    let regexPaginate = new RegExp(/page=([0-9]+)/);
    let pageExists = regexPaginate.test(search);
    let paginate = parseParams?.page;

    let filter = pageExists ? `?page=${paginate}` : '';
    Object.entries(values).forEach((item) => {
      if (item[1] != 0 || item[1]?.length > 0) {
        filter +=
          filter.length > 0
            ? `&${item[0]}=${item[1]}`
            : `?${item[0]}=${item[1]}`;
      }
    });
    navigate(`/competition${filter}`);
    setFilterModal(false);
  };

  // const onExcelExport = () => {
  //   window.location.href = `${getApiUrl()}/report/competition/excel/${search}`;
  // };

  return loading ? (
    <Loading />
  ) : (
    <>
      <Master>
        <TitleBar
          title='لیست مسابقات'
          createBtnTitle='ایجاد مسابقه'
          createPath='/competition/create'
          showFilterBtn={true}
          filter={() => setFilterModal(true)}
          showExcelBtn={false}
        />
        {/* <div className='row'>
          <div className='col-12 overflow-auto'>
            {context?.competitions?.data?.length > 0 ? (
              <table className='table table-hover table-striped overflow-hidden rounded-1 shadow-sm text-left'>
                <thead className='thead-persian-green text-left'>
                  <tr>
                    <th>#</th>
                    <th>تصویر</th>
                    <th>عنوان</th>
                    <th>شروع مسابقه</th>
                    <th>پایان مسابقه</th>
                    <th>لیست ثبت نام</th>
                    <th>مقام های مسابقه</th>
                    <th>عوامل احرایی</th>
                    <th>آی دی کارت عوامل اجرایی</th>
                    <th>بهترین مربی</th>
                    <th>وضعیت</th>
                    <th>عملیات</th>
                  </tr>
                </thead>
                <tbody>
                  {context?.competitions?.data?.map((item, index) => (
                    <tr key={item?.id}>
                      <td>
                        {countOfRecourd(
                          index,
                          context?.competitions?.meta?.pagination?.per_page,
                          context?.competitions?.meta?.pagination?.current_page,
                        )}
                      </td>
                      <td>
                        <img
                          src={item?.thumbnail?.path}
                          alt=''
                          style={{ width: '50px', height: '50px' }}
                        />
                      </td>
                      <td> {item?.title}</td>
                      <td>{dateToJalali(item?.start_at)}</td>
                      <td>{dateToJalali(item?.end_at)}</td>
                      <td>
                        <Link
                          target='_blank'
                          to={`/competition/competition-register?competition_id=${item?.id}`}
                          className='text-danger f-12 font-weight-bold c-pointer d-flex flex-row'
                        >
                          مشاهده
                        </Link>
                      </td>
                      <td>
                        <Link
                          target='_blank'
                          to={`/competition/competition-register/${item?.id}/rule`}
                          className='text-danger f-12 font-weight-bold c-pointer d-flex flex-row'
                        >
                          مشاهده
                        </Link>
                      </td>{' '}
                      <td>
                        <Link
                          target='_blank'
                          to={`/competition/${item?.id}/agent`}
                          className='text-danger f-12 font-weight-bold c-pointer d-flex flex-row'
                        >
                          مشاهده
                        </Link>
                      </td>{' '}
                      <td>
                        <Link
                          target='_blank'
                          to={`/id-card/competition/${item?.id}/agent`}
                          className='text-danger f-12 font-weight-bold c-pointer d-flex flex-row'
                        >
                          مشاهده
                        </Link>
                      </td>
                      <td>
                        <Link
                          target='_blank'
                          to={`/competition/${item?.id}/best-coach`}
                          className='text-danger f-12 font-weight-bold c-pointer d-flex flex-row'
                        >
                          مشاهده
                        </Link>
                      </td>
                      <td>
                        <span
                          className={`badge ${
                            item?.status == 1 ? 'badge-success' : 'badge-danger'
                          } badge-pill f-12`}
                        >
                          {item?.status == 1 ? 'فعال' : 'غیرفعال'}
                        </span>
                      </td>
                      <td>
                        <div className='d-flex flex-row'>
                          <Link
                            target='_blank'
                            to={`/competition/edit/${item?.id}`}
                            className='mx-2'
                          >
                            <i className='fad fa-edit f-16 text-success'></i>
                          </Link>
                          <Link
                            className='mx-2'
                            to='#'
                            onClick={(e) => {
                              e.preventDefault();
                              setModalRemoveObject(item);
                              setModalIsOpen(true);
                            }}
                          >
                            <i className='fad fa-trash f-16 text-danger'></i>
                          </Link>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            ) : (
              <div className='d-flex flex-row justify-content-center border p-3 my-3	'>
                <span className='f-13 font-weight-bold text-secondary'>
                  اطلاعاتی جهت نمایش یافت نشد.
                </span>
              </div>
            )}
          </div>
          {context.competitions?.data?.meta?.pagination?.total_pages > 1 && (
            <div className='col-12'>
              <div className='w-100 mt-4 d-flex'>
                <Pagination
                  totalPage={
                    context.competitions?.data?.meta?.pagination?.total_pages
                  }
                  basePath='/competition'
                  search={search}
                />
              </div>
            </div>
          )}
        </div> */}
        <Datatable
          data={context.competitions?.data}
          editUrl='/competition/edit'
          meta={context.competitions?.meta}
          search={search}
          setModalIsOpen={setModalIsOpen}
          setModalRemoveObject={setModalRemoveObject}
          basePagePath='/competition'
          columns={[
            'تصویر',
            'عنوان',
            'شروع مسابقه',
            'پایان مسابقه',
            'لیست ثبت نام',
            'مقام های مسابقه',
            'عوامل احرایی',
            'آی دی کارت عوامل اجرایی',
            'بهترین مربی',
            'رده بندی استان ها',
            'وضعیت',
          ]}
          rows={[
            { name: 'thumbnail.path', type: 'relation', relType: 'image' },
            { name: 'title', type: 'string' },
            { name: 'start_register_at', type: 'date' },
            { name: 'end_register_at', type: 'date' },
            {
              name: '',
              type: 'link',
              linkType: 'text',
              linkTitle: 'مشاهده',
              link: `/competition/competition-register?competition_id={id}`,
              params: ['id'],
            },
            {
              name: '',
              type: 'link',
              linkType: 'text',
              linkTitle: 'مشاهده',
              link: `/competition/competition-register/{id}/rule`,
              params: ['id'],
            },
            {
              name: '',
              type: 'link',
              linkType: 'text',
              linkTitle: 'افزودن/ویرایش',
              link: `/competition/{id}/agent`,
              params: ['id'],
            },
            {
              name: '',
              type: 'link',
              linkType: 'text',
              linkTitle: 'چاپ',
              link: `/competition/{id}/agent/users`,
              params: ['id'],
            },
            {
              name: '',
              type: 'link',
              linkType: 'text',
              linkTitle: 'افزودن/ویرایش',
              link: `/competition/{id}/best-coach`,
              params: ['id'],
            },

            {
              name: '',
              type: 'link',
              linkType: 'text',
              linkTitle: 'افزودن/ویرایش',
              link: `/competition/{id}/province-rank`,
              params: ['id'],
            },

            { name: 'status', type: 'status' },
          ]}
        />
      </Master>
      <RemoveModal
        id={modalRemoveObject?.id}
        modalIsOpen={modalIsOpen}
        removeItem={removeItem}
        removeLoading={removeLoading}
        setModalIsOpen={setModalIsOpen}
        title={`آیا از حذف مسابقه "${modalRemoveObject?.title}" مطمئن هستید ؟`}
      />

      <ModalCustom modalIsOpen={filterModal}>
        <div className='d-flex flex-row justify-content-between align-items-center border-bottom pb-2'>
          <span className=''>فیلتر مسابقات</span>
          <i
            className='far fa-times text-white f-20 mx-2 c-pointer'
            onClick={() => setFilterModal(false)}
          ></i>
        </div>
        <div className='w-100 my-3'>
          <Form
            initialValues={{
              sku: parseParams?.sku ?? '',
              title: parseParams?.title ?? '',
              type: parseParams?.type ?? 0,
              start_at: parseParams?.start_at,
              end_at: parseParams?.end_at,
            }}
            defaultActions={false}
            onSubmit={competitionFilter}
          >
            <div className='row'>
              <div className='col-12 col-md-6'>
                <Datepicker
                  name='start_at'
                  title='تاریخ شروع'
                  minDate='1370/01/01'
                />
              </div>{' '}
              <div className='col-12 col-md-6'>
                <Datepicker
                  name='end_at'
                  title='تاریخ پایان'
                  minDate='1370/01/01'
                />
              </div>
              <div className='col-12 col-md-6'>
                <Text
                  name='sku'
                  className='w-100'
                  containerClass='w-100'
                  title='کد شناسه مسابقه'
                />
              </div>
              <div className='col-12 col-md-6'>
                <Text
                  name='title'
                  className='w-100'
                  containerClass='w-100'
                  title='عنوان'
                />
              </div>
              <div className='col-12 col-md-6'>
                <Select
                  selectedElementExists={false}
                  title='نوع مسابقه'
                  options={context.types}
                  name='type'
                  optionLabel='title'
                  optionValue='id'
                />
              </div>
              <div className='col-12 d-flex flex-row justify-content-center align-items-center'>
                <span
                  className='btn px-5 btn-danger text-white f-12 my-3 mx-2 c-pointer'
                  onClick={() => setFilterModal(false)}
                >
                  انصراف
                </span>
                <button className='btn px-5 btn-info text-white f-12 my-3'>
                  فیلتر
                </button>
              </div>
            </div>
          </Form>
        </div>
      </ModalCustom>
    </>
  );
};

export default Competition;
